/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formDefaults.ts (Agents)
 🗓️ Created: 2025-01-15
 🧩 Description:
    Default form state values for Agents module.

────────────────────────────────────────────────────────────────*/

import { FormState, AgentStatus, AgentType, AgentStateMode } from '../types';

/**
 * Default form state
 */
export function getDefaultFormState(): FormState {
  return {
    // General
    agentName: '',
    extension: '',
    enabled: true,
    initialStatus: 'Logged Out',
    stateMode: 'auto',
    agentType: 'Inbound',
    recordCalls: false,
    maxConcurrentCalls: '1',
    
    // Behavior
    maxNoAnswer: '3',
    busyDelayTime: '90',
    rejectDelayTime: '90',
    noAnswerDelayTime: '30',
    contactTimeout: '20',
    wrapUpTime: '10',
    
    // Advanced
    rejectMultipleCalls: false,
    skipAgentWhileBusy: false,
    agentCooldown: '0',
    ignoreBusyAfterTimeout: false,
    
    createdAt: null,
    updatedAt: null
  };
}

/**
 * Status options
 */
export const STATUS_OPTIONS: AgentStatus[] = [
  'Available',
  'Available (On Demand)',
  'Logged Out',
  'On Break'
];

/**
 * Agent type options
 */
export const AGENT_TYPE_OPTIONS: AgentType[] = ['Inbound', 'Outbound', 'Callback'];

/**
 * State mode options
 */
export const STATE_MODE_OPTIONS: AgentStateMode[] = ['auto', 'manual'];

